import * as React from "react";
import { Circle as CircleGeometry } from "@progress/kendo-drawing/geometry";
import { Layout, Text } from "@progress/kendo-drawing";
import {
    Chart, ChartSeries, ChartSeriesItem,
    //   ChartCategoryAxis,
    //   ChartCategoryAxisItem,
    //   ChartTitle,
    ChartLegend,
    //   ChartSeriesItemTooltip,
    ChartTooltip, ChartSeriesLabels, ChartLegendItem,
    //   ChartSeriesItemTooltip,
} from "@progress/kendo-react-charts";
import { withTranslation } from "react-multi-lang";
import "hammerjs";
// import { Group, Path, geometry } from "@progress/kendo-drawing";

class KendoChartDashboard extends React.Component {

    constructor(props) {
        super(props);
        this.handleChartRefresh = this.handleChartRefresh.bind(this);
        this.state = {
            chartType: this.props.chartType,
            chartData: this.props.chartData,
            chartName: this.props.chartName,
            doRender: this.props.doRender
        }
        this.seriesLabels = {
            visible: true,
            padding: 3,
            font: 'bold 16px Arial, sans-serif'
        };
        this.center = undefined;
        this.radius = undefined;
        this.legendItemMargin = 10;
    }

    // customLegendItemVisual = args => {
    //     const { createVisual } = args;
    //     const visual = createVisual();
    //     const group = new Group();
    //     const rect = new geometry.Rect([0, 0], [150, 20]);
    //     group.append(visual);
    //     group.append(Path.fromRect(rect, { stroke: null }));

    //     return group;
    // };

    UNSAFE_componentWillReceiveProps(
        nextProps,
        nextState,
        prevProps,
        prevState,
        nextContext,
        prevContext
    ) {
        // if (nextProps.doRender && this.props.doRender) {
        this.setState({
            chartType: nextProps.chartType,
            chartData: nextProps.chartData,
            chartName: nextProps.chartName,
            doRender: false
        })
        // }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.doRender) {
            // this.setState({
            //     chartType: nextProps.chartType,
            //     chartData: nextProps.chartData,
            //     chartName: nextProps.chartName,
            //     doRender: false
            // })
            return true;
        }
        return false;
    }
    mapSeries = (item, idx) => (
        <ChartSeriesItem
            key={idx}
            color={item.color}
            data={item.barData}
            name={item.name}
            tooltip={{ visible: true, }}
            type={'bar'}
        >
            <ChartSeriesLabels
                format="C0"
                position="center"
                font="100 .8rem Poppins-Medium, sans-serif"
                color="#fff"
                background="none"
                content={this.labelContent}
            />
        </ChartSeriesItem>
    );

    handleChartRefresh(chartOptions, themeOptions, chartInstance) {
        if (this.props.doRender) {
            chartInstance.setOptions(chartOptions, themeOptions);
        }
    }

    defaultTooltipRender = (point) => {
        if (point !== undefined && point.point !== undefined) {
            if (this.state.chartType === 'donut')
                return `${point.point.category} : ${point.point.value}`;
            else
                return `${point.point.series.name} : ${point.point.value}`;
        }
    };

    labelContent = (point) => {
        if (point !== undefined && point !== undefined) {
            if(point.value !== 0){
                return `${point.value}`; 
            }
            
        }
        
    };

    onRender = (e) => {
        // The center and radius are populated by now.
        // We can ask a circle geometry to calculate the bounding rectangle for us.
        //
        // http://www.telerik.com/kendo-react-ui/components/drawing/api/geometry/Circle/
        const circleGeometry = new CircleGeometry(this.center, this.radius);
        const bbox = circleGeometry.bbox();
        let heading;
        // Render the text
        //
        // http://www.telerik.com/kendo-react-ui/components/drawing/api/Text/

        const displayTitle = this.state.chartName.split(":")
        const line1 = new Text(`${displayTitle[1]}`, [0, 0], {
            font: "600 .8rem Poppins-Medium, sans-serif",
        });
        let valueexist;
        this.state.chartData.filter((obj) => {
            if (obj.data !== 0) {
                valueexist = true;
            }
        })
        if (valueexist) {
            heading = new Text(`${displayTitle[0]}`, [5, 0], {
                font: "600 .7rem Poppins-Medium, sans-serif",
                fill: {
                    color: "#677EA6"
                }
                
            });
        } else {
            heading = new Text(`${displayTitle[0]}`, ["20px", 0], {
                font: "600 .7rem Poppins-Medium, sans-serif",
                fill: {
                    color: "#677EA6"
                }
            });
        }
        // const heading = new Text(`${displayTitle[0]}`, ["20px",0], {
        //      const heading = new Text(`${displayTitle[0]}`, [0,0], {
        //     font: "600 .7rem Poppins-Medium, sans-serif",
        //     fill: {
        //         color:"#677EA6"
        //     }
        // });

        // Reflow the text in the bounding box
        //
        // http://www.telerik.com/kendo-react-ui/components/drawing/api/Layout
        // http://www.telerik.com/kendo-react-ui/components/drawing/api/LayoutOptions
        const layout = new Layout(bbox, {
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            spacing: 5,
        });
        if (this.state.chartType === 'donut') {
            layout.append(line1, heading);
            layout.reflow();
        }
        // Draw it on the Chart drawing surface
        //
        // http://www.telerik.com/kendo-react-ui/components/charts/api/Chart/#toc-surface
        if (e.target.surface) {
            e.target.surface.draw(layout);
        }
    };

    visualHandler = (e) => {
        // Obtain parameters for the segments
        this.center = e.center;
        this.radius = e.innerRadius;

        // Create default visual
        return e.createVisual();
    };

    render() {
        return (
            <Chart className="dashboard-chart" onRender={this.onRender} renderAs={'svg'} onRefresh={this.handleChartRefresh.bind(this)}>
                <ChartTooltip render={this.defaultTooltipRender} />
                {/* <ChartTitle align="left" font="100 1rem Poppins-Bold, sans-serif" text={this.state.chartName} /> */}
                <ChartLegend labels={{ font: "100 .8rem Poppins-Medium, sans-serif" }} align="start" position="bottom" orientation={this.state.chartType === 'donut' ? "horizontal" : "vertical"} >
                    <ChartLegendItem
                        markers={{ margin: this.legendItemMargin, type: "circle", width: 8, height: 8 }}
                        labels={{ color: "#677EA6" }}
                    // visual = { this.customLegendItemVisual}
                    />
                </ChartLegend>
                <ChartSeries>
                    {this.state.chartType === "donut" ?
                        <ChartSeriesItem
                            type={this.state.chartType}
                            tooltip={{ visible: true, }}
                            padding={0}
                            size={40}
                            innerRadius={230}
                            data={this.state.chartData}
                            font="100 .8rem Poppins-Medium, sans-serif"
                            categoryField="name"
                            field="data"
                            visual={this.visualHandler}
                        >
                            <ChartSeriesLabels
                                format="C0"
                                position="center"
                                font="100 .8rem Poppins-Medium, sans-serif"
                                color="#fff"
                                background="none"
                                content={this.labelContent}
                            />
                        </ChartSeriesItem>
                        : this.state.chartData.map(this.mapSeries)}
                </ChartSeries>
            </Chart>
        )
    }
}
export default withTranslation(KendoChartDashboard);